import React, { FC, useState, useEffect, useRef } from 'react'
import {
  Container,
  StyledInput,
  ErrorText,
  Eye,
  StyledTextArea,
  IconInput,
  PropContainer,
  Prop,
  DeleteTag,
  PrefixText
} from './styles'
import { icons } from '../../icons'
import Label from '../label'
import StyledIcon from '../styled-icon'
import { useTranslation } from 'react-i18next'
import { getIn } from 'formik'
type InputProps = {
  values?:any,
  title:string,
  toolTip?:boolean,
  toolTipText?:string,
  placeholder:string,
  handleChange?:any,
  touched?:any,
  errors?:any,
  fieldName?:any,
  isPassword?:boolean,
  customStyles?:any,
  forgot?:boolean,
  onBlur?:any,
  handleBlur?:any,
  onFocus?:any,
  onFocusOut?:any,
  ref?:any,
  isTextArea?:any,
  containerCustom?:any,
  phoneNumber?:boolean,
  readOnly?:boolean,
  disabled?:boolean,
  masked?:boolean,
  mask?:string,
  handleKeyDown?:any,
  defaultValue?:any,
  type?:string,
  value?:any,
  required?:boolean,
  arrayFields?:boolean
  arrayName?:any,
  arrayIndex?:any,
  arrayFieldName?:any,
  manualErr?:any,
  manualTouched?:any,
  icon?:string,
  tags?:any,
  changeTags?:(tag:string) => void;
  isRestrictionIp?:boolean;
  prefix?:string;
  autoComplete?:string;
}

const protectedEntityNameFields = new Set([
  'name',
  'backup_name',
  'image_name',
  'destination_name',
  'title',
  'subject',
])

const Input:FC<InputProps> = (props) => {
  const [t] = useTranslation()
  const [show, setShow] = useState<boolean>(false)
  const [localError, setLocalError] = useState<any>(false)

  const {
    values,
    handleChange,
    touched,
    errors,
    fieldName,
    isPassword,
    title,
    toolTip=false,
    placeholder,
    customStyles,
    onFocus,
    ref,
    onFocusOut,
    isTextArea,
    containerCustom,
    handleBlur,
    readOnly,
    disabled,
    toolTipText,
    handleKeyDown,
    defaultValue,
    type,
    value,
    required,
    arrayFields=false,
    arrayName,
    arrayIndex,
    arrayFieldName,
    manualErr,
    manualTouched,
    icon,
    tags,
    changeTags,
    isRestrictionIp,
    prefix,
    autoComplete = 'off'
  } = props
  const TagRef:any = useRef()
  // console.log('tags', tags);
  const ipPattern = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])$/;
  // const ipPattern = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]?[0-9])(\/\d{1,2})?$/;

  const handleSpacebar = (event:any) => {
    if (event.code === 'Space' && changeTags) {
      if(isRestrictionIp && !ipPattern.test(values?.[fieldName]?.replaceAll(' ', ''))){
        setLocalError(`${t("RESTRICTION_IP_VALIDATE")}`)
        return
      }
      if(values?.[fieldName]?.length >= 20){
        setLocalError(`${t("STRING_VALIDATE_MAX")} 20 ${t("CHARACTERS")}`)
        return
      } else {
        changeTags(values?.[fieldName]?.replaceAll(' ', ''))
        setLocalError('')
        TagRef.current.value = ''
        handleChange('')
      }
    }
  };
  // useEffect(() => {
  //   setLocalError('')
  // },[tags])
  useEffect(() => {
    if(tags){
      window.addEventListener('keydown', handleSpacebar);
      return () => {
        window.removeEventListener('keydown', handleSpacebar);
      };
    }
  });
  const prefixRef:any = useRef()

  const fieldValue = getIn(values, fieldName);
  const fieldIdentifier = `${arrayFieldName || fieldName || ''}`
  const protectsEntityName = !isPassword && (
    protectedEntityNameFields.has(fieldIdentifier) || fieldIdentifier.endsWith('.name')
  )
  const fieldPath = fieldName || (arrayFields ? `${arrayName}[${arrayIndex}].${arrayFieldName}` : '')
  const fieldError = manualErr || getIn(errors, fieldPath);
  const fieldTouched = manualTouched || getIn(touched, fieldPath);
  const displayedError = (fieldTouched && fieldError) || localError
  const hasValidationError = Boolean(displayedError)
  const handleInputChange = (event:any) => {
    if (protectsEntityName && document.activeElement !== event.currentTarget) {
      event.currentTarget.value = `${fieldValue ?? value ?? defaultValue ?? ''}`
      return
    }
    if (changeTags && event.currentTarget.value === ' ') {
      return
    }
    handleChange?.(event)
  }
  const handleInputBlur = (event:any) => {
    onFocusOut?.()
    handleBlur?.(event)
  }
  return(
    <Container containerCustom={containerCustom}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
        <Label required={required} title={title} toolTip={toolTip} tooltipText={toolTipText} />
      </div>
      {icon ? 
        <IconInput>
          <img alt="" src={icon}/>
        </IconInput>
      : null}
      {isTextArea ? 
        <StyledTextArea
          $hasIcon={Boolean(icon)}
          customStyles={customStyles}
          ref={ref}
          error={fieldTouched && (fieldError || localError)}
          placeholder={placeholder}
          name={fieldName}
          aria-invalid={hasValidationError}
          data-validation-field={fieldPath || undefined}
          data-validation-error={hasValidationError || undefined}
          autoComplete={protectsEntityName ? 'off' : autoComplete}
          data-1p-ignore={protectsEntityName ? 'true' : undefined}
          data-lpignore={protectsEntityName ? 'true' : undefined}
          data-bwignore={protectsEntityName ? 'true' : undefined}
          data-form-type={protectsEntityName ? 'other' : undefined}
          value={fieldValue}
          readOnly={readOnly}
          disabled={disabled}
          onFocus={onFocus}
          onKeyDown={handleKeyDown}
          onBlur={handleInputBlur}
          onChange={handleInputChange}
        />
      :
        // phoneNumber || masked ? 
          // <InputMask
          //   mask={mask || '+99 (999) 999-99-99'}
          //   value={fieldValue}
          //   onChange={handleChange}
          // >
          //   {(inputProps) => (
          //     <StyledInput
          //       // {...inputProps} // Spread the props provided by InputMask
          //       // customStyles={customStyles}
          //       // ref={ref}
          //       // error={fieldTouched && fieldError}
          //       // placeholder={placeholder}
          //       // name={fieldName}
          //       // onFocus={onFocus}
          //       type={'tel'}
          //       // onKeyDown={handleKeyDown}
          //     />
          //   )}
          // </InputMask>
        // :
        <div
          style={{
            position: 'relative',
            width: '100%',
          }}
        >
          {prefix &&
            <div 
              style={{
                position: 'absolute',
                // transform: 'translateY(50%)',
                top:"15px",
                left:'10px',
                zIndex:10,
              }}
              ref={prefixRef}
            >
              <PrefixText>
                {prefix}-
              </PrefixText>
            </div>
          }
          <StyledInput
            $hasIcon={Boolean(icon)}
            customStyles={customStyles}
            style={prefix ? {paddingLeft:prefixRef?.current?.offsetWidth+10} : {}}
            ref={ref || TagRef}
            error={(fieldTouched && fieldError) || localError}
            defaultValue={defaultValue}
            placeholder={placeholder}
            name={fieldName}
            aria-invalid={hasValidationError}
            data-validation-field={fieldPath || undefined}
            data-validation-error={hasValidationError || undefined}
            autoComplete={protectsEntityName ? 'off' : autoComplete}
            data-1p-ignore={protectsEntityName ? 'true' : undefined}
            data-lpignore={protectsEntityName ? 'true' : undefined}
            data-bwignore={protectsEntityName ? 'true' : undefined}
            data-form-type={protectsEntityName ? 'other' : undefined}
            value={fieldValue ?? value}
            onFocus={onFocus}
            onKeyDown={handleKeyDown}
            readOnly={readOnly}
            disabled={disabled}
            onBlur={handleInputBlur}
            type={type ? type : (!show && isPassword) ? 'password' : 'text'}
            onChange={handleInputChange}
          />
        </div>
      }
      {isPassword ? 
        <Eye>
          <StyledIcon onClick={() => setShow(!show)} src={show ? icons.ShowPassword : icons.HidePassword}/>
        </Eye>
      : null}
      {displayedError ? <ErrorText>{displayedError}</ErrorText> : null}
      {tags !== ' ' && tags !== undefined && tags && tags?.length > 0 && 
        <div style={{
          display:'flex',
          flexWrap:"wrap",
          alignItems:'center',
          gap:'4px',
          marginTop:'10px'
          }}>
          {tags?.map((tag:string) => (
            <PropContainer key={tag}>
              <Prop>
                {tag}
              </Prop>
              {changeTags &&
                <DeleteTag onClick={() => changeTags(tag)} style={{width:'8px', height:'8px'}} src={icons.CloseIcon}/>
              }
              </PropContainer>
          ))}
        </div>
      }
    </Container>
  )
}

export default Input
